import * as React from "react";

export interface AddressProps {
  city: string;
  street: string;
  buildingNumber: string;
  creationDate: string;
}

const Address: React.FC<AddressProps> = ({
  city,
  street,
  buildingNumber,
  creationDate,
}) => (
  <div className="address">
    <div><strong>עיר:</strong> {city}</div>
    <div><strong>רחוב:</strong> {street}</div>
    <div><strong>מספר בניין:</strong> {buildingNumber}</div>
    <div><strong>נוצר בתאריך:</strong> {new Date(creationDate).toLocaleString()}</div>
  </div>
);

export default Address;